import { Amplify, Auth } from 'aws-amplify';
import { aws_exports } from '.';

export function initializeAmplify() {
  Amplify.configure(aws_exports);
  Auth.configure({ authenticationFlowType: 'USER_PASSWORD_AUTH' });
}
